import React from 'react'
import { Tab } from 'semantic-ui-react'

import EntryCategories from './components/EntryCategories'
import ServicesArrangement from './components/ServicesArrangement'
import PromotionCategory from './components/PromotionCategory'

import utils from '../../utils'

class AppCustomization extends React.Component {
  tabPanes = () => ({
    'entry-categories': {
      menuItem: 'Entry Categories',
      render: this.renderEntryScreen,
    },
    'services-arrangement': {
      menuItem: 'Services Arrangement',
      render: this.renderServicesArrangement,
    },
    'promotion-category': {
      menuItem: 'Promotion Category',
      render: this.renderPromotionCategory,
    }
  })

  onTabChange = index => {
    const { history } = this.props
    const tabs = Object.keys(this.tabPanes())
    const queryString = tabs[index] ? `?tab=${tabs[index]}` : ''

    history.push(`/app-customization${queryString}`)
  }

  renderEntryScreen = () => (
    <React.Fragment>
      <EntryCategories />
    </React.Fragment>
  )

  renderServicesArrangement = () => (
    <React.Fragment>
      <ServicesArrangement />
    </React.Fragment>
  )

  renderPromotionCategory = () => (
    <React.Fragment>
      <PromotionCategory />
    </React.Fragment>
  )

  render() {
    const params = utils.helpers.urlParams()
    const tab = params.tab || 'entry-categories'
    const tabIndex = Object.keys(this.tabPanes()).indexOf(tab)

    return (
      <Tab
        activeIndex={tabIndex < 0 ? 0 : tabIndex}
        menu={{ pointing: true }}
        panes={Object.values(this.tabPanes())}
        onTabChange={(e, { activeIndex }) => this.onTabChange(activeIndex)}
      />
    )
  }
}

export default AppCustomization



// WEBPACK FOOTER //
// ./src/containers/appCustomization/index.js